module.exports = __webpack_public_path__ + "static/media/image1.0aede7f6.jpg";